<div class="flex-grow-1 py-3 mt-4">
  <div class="mb-3">
    <h1 class="fs-5 fw-bold mb-0">Affiliate payment</h1>
  </div>

  <div id="accounting" class="card shadow border-0 mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="filters" (ngSubmit)="fetchAll()">
        <div class="row g-3">
          <div class="col-auto">
            <app-date-range-selector (dateChanged)="updateRange($event)"
              [shortTimezone]="true"
            [showTimezone]="false"></app-date-range-selector>
          </div>

          <div class="col">
            <label class="form-label small fw-bold">Terms</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-file-text"></i></span>
              <app-dropdown-select [multiple]="true" formControlName="paymentTerms">
                @for (paymentTerm of paymentTermList; track paymentTerm) {
                  <app-dropdown-select-option [value]="paymentTerm">
                    {{ 'paymentTerm.' + paymentTerm | translate }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="col">
            <label class="form-label small fw-bold">Status</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-check"></i></span>
              <app-dropdown-select [multiple]="true" formControlName="status">
                @for (invoiceStatus of invoiceStatusList; track invoiceStatus) {
                  <app-dropdown-select-option [value]="invoiceStatus">
                    {{ 'invoiceStatus.' + invoiceStatus | translate }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="col-auto">
            <label class="form-label small fw-bold">Deferred</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-clock"></i></span>
              <select formControlName="deferred" class="form-control">
                <option [ngValue]="null">All</option>
                <option [ngValue]="1">Yes</option>
                <option [ngValue]="0">No</option>
              </select>
            </div>
          </div>

          <div class="col">
            <label class="fw-bold small">Affiliate</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <app-dropdown-select [multiple]="true" formControlName="partnerId">
                @for (affiliate of affiliates; track affiliate) {
                  <app-dropdown-select-option [value]="affiliate.id">
                    {{ affiliate }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="col-auto d-flex align-items-end justify-content-end gap-1">
            <button type="submit" class="btn btn-primary fw-bold">Apply</button>
            <button (click)="downloadMode = 'csv'" [class.active]="downloadMode === 'csv'" type="button"
              class="btn btn-outline-primary">CSV
            </button>
            <button (click)="downloadMode = 'zip'" [class.active]="downloadMode === 'zip'" type="button"
              class="btn btn-outline-primary">ZIP
            </button>
          </div>
        </div>
      </form>

      <div class="table-responsive">
        <table class="table table-striped table-hover align-middle mt-2">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th scope="col">
                <input type="checkbox" (change)="toggleSelectAll($event)" [checked]="isAllSelected()">
              </th>
              <th tableSorterHeader="startingAt">Period</th>
              <th tableSorterHeader="partner">Affiliate</th>
              <th tableSorterHeader="invoice.reference">Ref/Number</th>
              <th tableSorterHeader="totalAmountTaxExcl">Excl. VAT</th>
              <th>VAT</th>
              <th tableSorterHeader="totalAmountTaxIncl">Incl. VAT</th>
              <th tableSorterHeader="paymentTerms">Terms</th>
              <th tableSorterHeader="invoice.status">Accounted</th>
              <th tableSorterHeader="invoice.status">Status</th>
              <th>Affiliate invoice</th>
              <th class="text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (billingRequest of billingRequests; track billingRequest) {
              <tr [class.table-active]="isSelected(billingRequest)">
                <td>
                  <input type="checkbox" class="selectRow" (click)="selectBillingRequest(billingRequest)"
                    [checked]="isSelected(billingRequest)">
                </td>
                <td>{{ billingRequest.startingAt | date: 'dd/MM/yyyy' }}
                  - {{ billingRequest.endingAt | date: 'dd/MM/yyyy' }}
                </td>
                <td>
                  <a
                    [routerLink]="['/partners', billingRequest.partnerId, 'activity']">{{ billingRequest.partnerDetails?.companyName }}
                  ({{ billingRequest.partnerId }})</a>
                </td>
                <td>
                  @if (billingRequest.invoice && !billingRequest.deferred) {
                    {{ billingRequest.invoice.reference }}
                  }
                </td>
                <td>
                  @if (billingRequest.deferred) {
                    {{ billingRequest.currencyTotalAmountTaxExcl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                  }
                  @if (!billingRequest.deferred && billingRequest.invoice) {
                    {{ billingRequest.invoice.currencyTotalAmountTaxExcl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                  }
                </td>
                <td>
                  @if (billingRequest.deferred) {
                    {{ billingRequest.getVatPercent() / 100 | percent }}
                  }
                  @if (!billingRequest.deferred && billingRequest.invoice) {
                    {{ billingRequest.invoice.getVatPercent() / 100 | percent }}
                  }
                </td>
                <td>
                  @if (billingRequest.deferred) {
                    {{ billingRequest.currencyTotalAmountTaxIncl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                  }
                  @if (!billingRequest.deferred && billingRequest.invoice) {
                    {{ billingRequest.invoice.currencyTotalAmountTaxIncl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                  }
                </td>
                <td>{{ 'paymentTerm.' + billingRequest.paymentTerms | translate }}</td>
                <td>
                  @if (billingRequest.invoice?.isAccounted()) {
                    <span class="text-success">Yes</span>
                  }
                  @if (!billingRequest.invoice?.isAccounted()) {
                    <span class="text-warning">No</span>
                  }
                </td>
                <td class="text-success">
                  @if (billingRequest.deferred) {
                    <span class="badge bg-success">Deferred</span>
                  }
                  @if (!billingRequest.deferred && billingRequest.invoice) {
                    <span
                      [ngClass]="billingRequest.invoice.getStatusClass()" class="badge">
                      {{ 'invoiceStatus.' + billingRequest.invoice.status | translate }}
                    </span>
                  }
                </td>
                <td>
                  @if (billingRequest.invoice?.invoiceFile) {
                    <button
                      (click)="openInvoiceFile(billingRequest)"
                      [title]="'View the invoice issued by the affiliate (' + $safeNavigationMigration(billingRequest.invoice?.invoiceFile?.filename) + ')'"
                      class="btn btn-outline-success btn-sm fw-bold text-nowrap" type="button">
                      <i class="bi bi-file-earmark-check me-1"></i>View
                    </button>
                  } @else if (billingRequest.invoice) {
                    <button
                      (click)="openInvoiceFile(billingRequest)"
                      title="Upload the invoice issued by the affiliate"
                      class="btn btn-outline-secondary btn-sm fw-bold text-nowrap" type="button">
                      <i class="bi bi-cloud-arrow-up me-1"></i>Upload
                    </button>
                  }
                </td>
                <td class="text-end">
                  @if (billingRequest.deferred && !billingRequest.invoice) {
                    <button
                      (click)="recalculateDeferred(billingRequest)"
                      title="Recalculate the deferred amounts (an invoice is created if the payment threshold is reached)"
                      class="btn btn-outline-primary btn-sm me-2" type="button">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  }
                  @if (billingRequest.invoice && billingRequest.invoice.id && billingRequest.invoice.reference) {
                    <a
                      [href]="invoiceService.getDownloadPdfUrl(billingRequest.invoice.id)"
                      [download]="billingRequest.invoice.reference + '.pdf'"
                      title="Download the invoice PDF" class="btn btn-outline-success btn-sm me-2">
                      <i class="bi bi-download"></i>
                    </a>
                  }
                  @if (billingRequest.invoice?.isWaitingForApproval()) {
                    <button
                      (click)="recalculate(billingRequest)"
                      title="Recalculate the invoice amounts over the period"
                      class="btn btn-outline-primary btn-sm me-2" type="button">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>

                    <button
                      (click)="updateStatus('invoice_validated', billingRequest)"
                      title="Validate the invoice: it becomes visible to the affiliate and is sent by email"
                      class="btn btn-outline-success btn-sm me-2">
                      <i class="bi bi-check-lg"></i>
                    </button>
                  }
                  @if (billingRequest.invoice?.isValidated()) {
                    <button
                      (click)="updateStatus('payment_in_progress', billingRequest)"
                      title="Flag as accounted (payment in progress)"
                      class="btn btn-outline-info btn-sm me-2">
                      <i class="bi bi-journal-check"></i>
                    </button>
                  }
                  @if (billingRequest.invoice?.isAccounted()) {
                    <button
                      (click)="updateStatus('paid', billingRequest)"
                      title="Flag as paid: the conversions of the period are marked as paid"
                      class="btn btn-outline-success btn-sm me-2">
                      <i class="bi bi-check2-all"></i>
                    </button>
                  }
                  @if (!billingRequest.invoice?.isPaid()) {
                    <button
                      (click)="delete(billingRequest)" appConfirm title="Delete the invoice"
                      class="btn btn-outline-danger btn-sm">
                      <i class="bi bi-trash"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>

      <div class="batch-actions mt-4">
        <a [href]="invoiceService.getDownloadUrl(selectedBillingRequests, downloadMode)"
          [class.disabled]="!selectedBillingRequests.length"
          [download]="'invoices.' + downloadMode" class="btn btn-outline-primary fw-bold">
          <i class="bi bi-download me-2"></i>Download selection
        </a>

        <button (click)="updateStatus('payment_in_progress')" type="button"
          class="btn btn-outline-primary fw-bold ms-2">
          <i class="bi bi-flag me-2"></i>Flag selection as accounted
        </button>

        <button (click)="updateStatus('paid')" type="button" class="btn btn-outline-primary fw-bold ms-2">
          <i class="bi bi-flag me-2"></i>Flag selection as paid
        </button>
      </div>
    </div>
  </div>
</div>
